module.exports = __webpack_public_path__ + "static/media/user-icon.d9fddc59.svg";